<template>
    <v-container>
        <div>
          <h1 style="color: darkorange;">About</h1>
            <h3>Current Version:   {{ this.items[0].versionNo }}</h3>
            <h4>Released:   {{ this.items[0].releaseDate }}</h4>
            <br>
            <h2>Version History:</h2>
            <v-card
                color="oug"
                class="pa-1 mx-auto text-center justify-center"
                max-width="600"
                elevation="24"
                >
                <v-card-title class="text-h6 white--text">
                    Versions
                    <v-spacer></v-spacer>
                    <a href="https://www.bqld.au/Privacy_Policy.html" target="blank">Privacy Policy</a>
                </v-card-title>
                <v-card-subtitle class="white--text" align="start">
                    This section contains a list of versions with the details of each release contained within.
                </v-card-subtitle>
                <div>
                    <v-dialog v-model="loadingDialog" hide-overlay persistent width="300">
                    <v-card color="oug" dark>
                        <v-card-text>
                        Loading Versions. Please Stand By
                        <v-progress-linear
                            indeterminate
                            color="white"
                            class="mb-0"
                        ></v-progress-linear>
                        </v-card-text>
                    </v-card>
                    </v-dialog>
                </div>
                <v-expansion-panels focusable>
                    <v-expansion-panel v-for="(version, i) in items" :key="i">
                    <v-expansion-panel-header
                        >{{ version.versionNo }}
                        <v-spacer></v-spacer>
                    </v-expansion-panel-header>
                    <p></p>
                    <v-expansion-panel-content class="justify-start">
                       <h4 style="color: darkorange;"> {{ version.description }} </h4>
                       <v-divider></v-divider>
                    <v-tabs
                        v-model="tab"
                        color="orange accent-4"
                        fixed-tabs
                        >
                        <v-tab
                            v-for="item in version.updates"
                            :key="item.title"
                        >
                            {{ item.title }}
                        </v-tab>
                    </v-tabs>

                    <v-tabs-items v-model="tab">
                        <v-tab-item
                            v-for="item in version.updates"
                            :key="item.title"
                        >
                            <v-card flat class="pa-1">
                            <v-card-text 
                                class="pa-1 text-center"
                                v-for="(content, i) in item.content"
                                :key="i"
                            >
                            <ul align="start">
                                <li>{{ content }}</li>
                            </ul>
                            </v-card-text>
                            </v-card>
                        </v-tab-item>
                    </v-tabs-items>
                    </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
                </v-card>
        
        </div>
    </v-container>
</template>

<script>

import versionControl from "../data/versionControl";
export default {
    data: () => ({
        loadingDialog: false,
        tab: null,
        items: versionControl,
    }),
    created() {
    }
}
</script>

<style>
a:link {
  color: green; 
  background-color: transparent; 
  text-decoration: none;
}

a:visited {
  color: pink;
  background-color: transparent;
  text-decoration: none;
}

a:hover {
  color: red;
  background-color: transparent;
  text-decoration: underline;
}

a:active {
  color: yellow;
  background-color: transparent;
  text-decoration: underline;
}
</style>